/**
 * Design tokens for the application
 * This centralizes all color definitions and other design values
 * to maintain consistency and make theme changes easier
 */

export const colors = {
  // Text colors
  headingColor: "primary.700",
  subHeadingColor: "primary.500",
  bodyText: "primary.700",
  disclaimerText: "primary.700",
  resultHeadingColor: "primary.600",
  helpTextColor: "gray.500",
  linkColor: "primary.500",
  additionalInfoColor: "primary.700",
  whiteText: "white",
  metaText: "gray.500",  // For timestamps, small secondary information
  versionText: "primary.600", // For version numbers in footer
  accent: "accent.500",
  
  // Home page specific colors
  heroHeadingColor: "primary.600",  // Main page heading
  heroAccentColor: "secondary.500", // Accent color for hero section
  featureIconColor: "secondary.500", // Feature icon color
  featureTitleColor: "secondary.500", // Feature title color
  featureTextColor: "primary.800", // Feature description text
  
  // UI element colors
  cardHeaderBg: "primary.50",
  cardBg: "background.200",
  borderColor: "background.200",
  subtleBorderColor: "background.100",
  accentBorderColor: "primary.100",
  hoverBg: "background.100",
  selectedBorderColor: "primary.300",
  buttonHoverBg: "background.100",
  
  // Background colors
  pageBackground: "background.100",
  footerBackground: "background.200",
  headerBackground: "background.200",
  footerBorder: "background.300",
  footerDivider: "background.400",
  contentBackground: "background.100",
  
  // Icon colors
  iconColor: "gray.400", // For standard icons
  
  // Status colors 
  successColor: "green.500",    // For success indicators
  warningColor: "orange.400",  // For warnings
  errorColor: "red.500",       // For errors
  infoColor: "blue.500",       // For information
  
  // Badge colors 
  badgeBackground: "secondary.50",
  badgeText: "secondary.700"
};

export const shadows = {
  cardShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
  hoverShadow: "0 4px 12px rgba(0, 0, 0, 0.15)"
};

export const spacing = {
  sectionPadding: { base: 4, md: 6, lg: 8 },
  containerMaxWidth: "6xl"
};
